import errepar from "../../../assets/clientes/errepar.png";
import itbc from "../../../assets/clientes/itbc.png";
import intermedia from "../../../assets/clientes/intermedia.png";
import adviters from "../../../assets/clientes/adviters.png";
import tisa from "../../../assets/clientes/tisa.png";

export const ClientList = [
  {
    src: errepar,
    alt: "Errepar",
  },
  {
    src: itbc,
    alt: "ITBC",
  },
  {
    src: intermedia,
    alt: "Intermedia",
  },
  {
    src: adviters,
    alt: "Adviters",
  },
  {
    src: tisa,
    alt: "TISA",
  },
];
